import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { IntroSection } from '../components/home/IntroSection';
import { StatsCounter } from '../components/home/StatsCounter';
import { TemplateCarousel } from '../components/home/TemplateCarousel';
import { PricingPreview } from '../components/home/PricingPreview';
import { HowItWorks } from '../components/home/HowItWorks';
import { CTASection } from '../components/home/CTASection';
import { Helmet } from 'react-helmet-async';
export function Home() {
  const schemaMarkup = {
    '@context': 'https://schema.org',
    '@graph': [{
      '@type': 'LocalBusiness',
      '@id': 'https://bright-pixxel.com/#organization',
      name: 'Bright Pixxel Studios',
      alternateName: 'Bright Pixxel',
      description: 'UK-based web design agency specializing in affordable, professional websites that load fast and convert. Expert web design, e-commerce solutions, SEO services and website maintenance packages. Transparent pricing from £399 Inc VAT.',
      url: 'https://bright-pixxel.com',
      telephone: '',
      email: 'info@bright-pixxel.com',
      logo: {
        '@type': 'ImageObject',
        url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png',
        width: 600,
        height: 600
      },
      image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png',
      priceRange: '£399 - £1,796.40',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'GB'
      },
      areaServed: {
        '@type': 'Country',
        name: 'United Kingdom'
      },
      currenciesAccepted: 'GBP',
      paymentAccepted: 'Cash, Credit Card, Bank Transfer',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        bestRating: '5',
        ratingCount: '500'
      },
      sameAs: ['https://facebook.com/brightpixxelstudios', 'https://twitter.com/brightpixxel', 'https://instagram.com/brightpixxelstudios', 'https://linkedin.com/company/bright-pixxel-studios']
    }, {
      '@type': 'WebSite',
      '@id': 'https://bright-pixxel.com/#website',
      url: 'https://bright-pixxel.com',
      name: 'Bright Pixxel Studios',
      description: 'UK-based web design agency specializing in affordable, professional websites that load fast and convert. Expert web design, e-commerce solutions, SEO services and website care plans.',
      publisher: {
        '@id': 'https://bright-pixxel.com/#organization'
      },
      inLanguage: 'en-GB',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://bright-pixxel.com/?s={search_term_string}',
        'query-input': 'required name=search_term_string'
      }
    }, {
      '@type': 'WebPage',
      '@id': 'https://bright-pixxel.com/#webpage',
      url: 'https://bright-pixxel.com',
      name: 'Bright Pixxel Studios | UK Web Design & E-commerce from £399',
      isPartOf: {
        '@id': 'https://bright-pixxel.com/#website'
      },
      about: {
        '@id': 'https://bright-pixxel.com/#organization'
      },
      description: 'UK-based websites that load fast and convert. Web design, e-commerce, SEO and care plans. Transparent pricing from £399 Inc VAT.',
      inLanguage: 'en-GB',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://bright-pixxel.com'
        }]
      }
    }, {
      '@type': 'Service',
      serviceType: 'Web Design',
      provider: {
        '@id': 'https://bright-pixxel.com/#organization'
      },
      areaServed: {
        '@type': 'Country',
        name: 'United Kingdom'
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Web Design Services',
        itemListElement: [{
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Bronze Web Design Package',
            description: 'Up to 5 pages, responsive design, enquiry form, blog option, basic SEO, 1 business email'
          },
          price: '399',
          priceCurrency: 'GBP'
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Silver Web Design Package',
            description: 'Up to 10 pages, branding + favicon, 3 business emails, SEO setup, domain + SSL, 30-day support'
          },
          price: '599',
          priceCurrency: 'GBP'
        }, {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Gold Web Design Package',
            description: 'Up to 15 pages, logo + trust badges, advanced SEO, payment links, content writing included, GA + GSC setup'
          },
          price: '899',
          priceCurrency: 'GBP'
        }]
      }
    }]
  };
  return <>
      <Helmet data-id="element-1463">
        <title data-id="element-1464">
          Bright Pixxel Studios | UK Web Design & E-commerce from £399
        </title>
        <meta name="description" content="UK-based websites that load fast and convert. Web design, e-commerce, SEO and maintenance packages. Transparent pricing from £399 Inc VAT." data-id="element-1465" />
        <meta name="keywords" content="web design UK, affordable web design, e-commerce website, SEO services, website maintenance, UK web developer, responsive web design, professional websites" data-id="element-1466" />
        <link rel="preconnect" href="https://images.unsplash.com" data-id="element-1467" />
        <link rel="preconnect" href="https://uploadthingy.s3.us-west-1.amazonaws.com" data-id="element-1468" />
        <link rel="dns-prefetch" href="https://images.unsplash.com" data-id="element-1469" />
        <link rel="dns-prefetch" href="https://uploadthingy.s3.us-west-1.amazonaws.com" data-id="element-1470" />
        <script type="application/ld+json" data-id="element-1471">
          {JSON.stringify(schemaMarkup)}
        </script>
        <link rel="canonical" href="https://bright-pixxel.com" data-id="element-1472" />
        <meta property="og:locale" content="en_GB" data-id="element-1473" />
        <meta property="og:type" content="website" data-id="element-1474" />
        <meta property="og:title" content="Bright Pixxel Studios | UK Web Design & E-commerce from £399" data-id="element-1475" />
        <meta property="og:description" content="UK-based websites that load fast and convert. Web design, e-commerce, SEO and maintenance packages. Transparent pricing from £399 Inc VAT." data-id="element-1476" />
        <meta property="og:url" content="https://bright-pixxel.com" data-id="element-1477" />
        <meta property="og:site_name" content="Bright Pixxel Studios" data-id="element-1478" />
        <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-1479" />
        <meta property="og:image:width" content="1200" data-id="element-1480" />
        <meta property="og:image:height" content="630" data-id="element-1481" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-1482" />
        <meta name="twitter:title" content="Bright Pixxel Studios | UK Web Design & E-commerce from £399" data-id="element-1483" />
        <meta name="twitter:description" content="UK-based websites that load fast and convert. Web design, e-commerce, SEO and maintenance packages. Transparent pricing from £399 Inc VAT." data-id="element-1484" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/qh74mEBb962nRk6qjvv9uT/Geometric_Logo_of_Bright_Pixxel_Studio.png" data-id="element-1485" />
      </Helmet>
      <HeroSection data-id="element-1486" />
      <section className="py-8 md:py-10 bg-[#212C34] relative" data-id="element-1487">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1488">
          <StatsCounter data-id="element-1489" />
        </div>
      </section>
      <IntroSection data-id="element-1490" />
      <TemplateCarousel data-id="element-1491" />
      <PricingPreview data-id="element-1492" />
      <HowItWorks data-id="element-1493" />
      <CTASection data-id="element-1494" />
    </>;
}